import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ThemeProvider } from '../../theme/ThemeProvider';
import English from '../../translations/en.json';
import { COMPONENT_DATA_ATTRIBUTE_NAME } from '../../constants';
import { ProductPayWithCoinsCard } from './ProductPayWithCoinsCard';
import { ProductPayWithCoinsType, ProductPayWithCoinsCardProps } from './ProductPayWithCoinsCard.types';

export const renderComponent = (domElement: Element | null) => {
  if (domElement) {
    const attributeData = domElement.getAttribute(COMPONENT_DATA_ATTRIBUTE_NAME);

    if (!attributeData) {
      return;
    }
    const componentData = JSON.parse(attributeData) as ProductPayWithCoinsCardProps;

    if (!Object.values(ProductPayWithCoinsType).includes(componentData.type)) {
      return;
    }

    const queryClient = new QueryClient();

    ReactDOM.render(
      <QueryClientProvider client={queryClient}>
        <IntlProvider locale="en" defaultLocale="en" messages={English} onError={() => {}}>
          <ThemeProvider>
            <ProductPayWithCoinsCard
              type={componentData.type}
              name={componentData.name}
              id={componentData.id}
              domElement={domElement}
            />
          </ThemeProvider>
        </IntlProvider>
      </QueryClientProvider>,
      domElement,
    );
  }
};
